import * as React from 'react';
import styled from 'styled-components';

// ############################ Imported from Old UI ###########################

export interface ISubtitleProps {
  dataAt?: string;
  tabIndex?: number;
  className?: string;
  fontWeight?: string;
  fontFamily?: string;
  alignLeft?: boolean;
  color?: string;
  fontSize?: string;
  dataTestId?: string;
  withLegalReferrer?: boolean;
}

// tslint:disable-next-line:variable-name
const SSubtitle = styled.h3<{
  fontWeight?: string;
  alignLeft: boolean;
  fontFamily?: string;
  color?: string;
  fontSize?: string;
  'data-testid'?: string;
}>(({ theme, fontWeight, alignLeft, color, fontSize }) => {
  return `
    color: ${color === 'primary' ? theme.colors.primaryBright : theme.colors.primaryBackground};
    margin-bottom: ${theme.spacing.mediumLarger}px;
    font-size: ${theme.font.size.smallMedium};
    font-family: ${theme.font.family};
    padding: 0;
    font-size: ${fontSize ? fontSize : '16px'};
    font-weight: ${fontWeight === 'bold' ? theme.font.weight.bolder : theme.font.weight.medium};
    line-height: 1.19;
    text-align: ${alignLeft ? 'left' : 'center'};
  `;
});

// tslint:disable-next-line:variable-name
const onlineSubtitle: React.FC<ISubtitleProps> = ({ dataTestId, children, alignLeft, ...props }) => (
  <SSubtitle
    {...{
      ...props,
      'data-testid': dataTestId,
      'data-at': props.dataAt ? props.dataAt : 'subtitle',
      alignLeft: typeof alignLeft !== 'undefined' ? alignLeft : true,
      tabIndex: 0,
    }}
  >
    {children}
  </SSubtitle>
);

export default onlineSubtitle;
